import LocationEpisode, { LocationEpisodeOptions } from 'models/LocationEpisode';
import { ProgressUpdatePayload } from 'services/api/activity';
import http from 'services/http';

type CreateParams = {
  locationEpisodeId: string;
  enteredAt?: string | Date;
  progressUpdates?: ProgressUpdatePayload[];
};

export async function createLocationEpisodeAdmission({ locationEpisodeId, ...params }: CreateParams) {
  return http
    .post<LocationEpisodeOptions>(`location_episodes/${locationEpisodeId}/location_episode_admissions`, params)
    .then((res) => new LocationEpisode(res.data));
}
